import React from 'react';
import PropTypes from 'prop-types';

/**
 * MetricCard - Reusable card component for displaying financial metrics
 * Used in ValuationDashboard to show key financial data
 */
const MetricCard = ({
  icon: Icon,
  label,
  title,
  value,
  supplementaryText,
  iconGradient,
  labelColor,
  labelBgColor,
  borderHoverColor
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-md p-5 border border-gray-100 hover:shadow-lg hover:border-${borderHoverColor}-200 transition-all duration-300`}>
      <div className="flex items-center justify-between mb-3">
        <div className={`p-2.5 bg-gradient-to-br ${iconGradient} rounded-lg`}>
          <Icon size={20} className={`text-${labelColor}-600`} />
        </div>
        <span className={`text-xs font-semibold text-${labelColor}-600 bg-${labelBgColor}-50 px-2.5 py-1 rounded-full`}>
          {label}
        </span>
      </div>
      <p className="text-gray-500 text-xs font-medium mb-1">{title}</p>
      <p className="text-2xl font-bold text-gray-900 mb-1">{value}</p>
      {supplementaryText && (
        <p className={`text-${labelColor}-600 text-xs font-medium`}>
          {supplementaryText}
        </p>
      )}
    </div>
  );
};

MetricCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  supplementaryText: PropTypes.node,
  iconGradient: PropTypes.string.isRequired,
  labelColor: PropTypes.string.isRequired,
  labelBgColor: PropTypes.string.isRequired,
  borderHoverColor: PropTypes.string.isRequired
};

export default MetricCard;
